export default "__VITE_ASSET__CwH_fqt8__"